import { Injectable } from '@angular/core';
import { RestService } from '@abp/ng.core';
import { Observable } from 'rxjs';
import { SaasTenantDto } from '@volo/abp.ng.saas/proxy';
import { CloneTenantDto } from './models';

@Injectable({ providedIn: 'root' })
export class CustomTenantService {
  constructor(private restService: RestService) {}

  clone(input: CloneTenantDto): Observable<SaasTenantDto> {
    return this.restService.request<any, SaasTenantDto>({
      method: 'POST',
      url: '/api/saas/tenants/duplicate',
      body: input,
    });
  }
}
